import React from "react";
import { Box } from "@mui/material";
import { getPositionColor } from "../../config/theme";

interface PositionChipProps {
  position: string;
  /** sm = compact table cell, md = default. */
  size?: "sm" | "md";
}

/**
 * Solid position badge (QB/RB/WR/TE/K/DST) in the canonical position color.
 * Single source for the previously-duplicated per-file position chips.
 */
export default function PositionChip({ position, size = "md" }: PositionChipProps) {
  const color = getPositionColor(position);
  const height = size === "sm" ? 20 : 24;
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height,
        px: size === "sm" ? 0.75 : 1,
        bgcolor: color,
        color: "#fff",
        fontWeight: 700,
        fontSize: size === "sm" ? 10 : 12,
        lineHeight: 1,
        borderRadius: "3px",
        letterSpacing: "0.02em",
        flexShrink: 0,
      }}
    >
      {position}
    </Box>
  );
}
